import React, {Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";

import {Can} from "../../../../ability-context";

import {updateUserPassword} from "../../../../creators/user.password";
import {updateUserEmail} from "../../../../creators/user.email";

import {Button} from "../../../components/Button";
import {EmailInputField, PasswordInputField, TextInputField} from "../../../components/FormField";
import {fetchCurrentUser, updateCurrentUser} from "../../../../creators/currentUser";
import Title from "../../../components/Title";
import {config} from "../../../../config";
import history from "../../../../libs/history";
import Helmet from "react-helmet";
import {
    cancelRequestSuppressionUser,
    requestSuppressionUser
} from "../../../../creators/user.requestSuppression";
import createLink from "../../../../libs/createLink";

class SettingsPasswordEmail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newEmail: "",
            checkNewEmail: "",
            emailPassword: "",
            emailError: false,

            passwordEmailSent : false,

            suppressionPassword : "",
            suppressionError : false,

            click: ''
        };
        this.handleValue = this.handleValue.bind(this);
        this.handleSubmitEmail = this.handleSubmitEmail.bind(this);
        this.handleSubmitPassword = this.handleSubmitPassword.bind(this);
        //this.handleSubmitSuppression = this.handleSubmitSuppression(this);

        this.props.fetchCurrentUser();
    }

    componentDidUpdate(prevProps) {

        if(prevProps.userEmail !== this.props.userEmail){
            this.setState({
                newEmail: "",
                checkNewEmail: "",
                emailPassword: "",
                emailError: false,
            });
            this.props.fetchCurrentUser();
        }
        if(prevProps.requestSuppressionAccount !== this.props.requestSuppressionAccount){
            this.setState({
                suppressionPassword : "",
                suppressionError : false
            });
            this.props.fetchCurrentUser();
        }
    }


    handleValue(name, value){
        this.setState({[name]: value});
    }

    handleSubmitEmail(event) {
        event.preventDefault();
        event.stopPropagation();
        if(this.state.newEmail !== this.state.checkNewEmail){
            this.setState({emailError: true});
        } else {
            this.props.updateUserEmail(this.props.currentUser._id, {email: this.state.newEmail, currentPassword: this.state.emailPassword});
        }
    }

    handleSubmitPassword(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.updateUserPassword();
        this.setState({passwordEmailSent:true})
    }

    handleSubmitSuppression(event) {
        event.preventDefault();
        event.stopPropagation();
        if(!this.state.suppressionPassword.length){
            this.setState({suppressionError: true});
        } else {
            this.props.requestSuppressionUser(this.props.currentUser._id, {currentPassword: this.state.suppressionPassword});
        }
    }

    render() {

        return (
            <Fragment>
                <div className="settings-wrapper">
                    <Helmet>
                        <title>{config.preTitle}Email & mot de passe{config.postTitle}</title>
                    </Helmet>
                    <div className={"block"}>
                        <form onSubmit={(e) => this.handleSubmitEmail(e)}>
                            <div className="content">
                                <Title className={"settings-title"} heading={"heading-2"} display={"display-2"}>Email & mot
                                    de passe</Title>
                                <h4 className="settings-sub-title">Adresse email</h4>
                                <span className="edit-span"><b>ATTENTION</b> : Une fois votre adresse email changée un nouveau courriel vous sera envoyé pour confirmer la nouvelle adresse.</span>
                                <label className="label-title">Adresse email actuelle</label>
                                <TextInputField value={this.props.currentUser.email.address}
                                                disabled={true}
                                                className="settings-text"/>

                                <label className="label-title">Nouvelle adresse email</label>
                                <EmailInputField value={this.state.newEmail}
                                                 required={true}
                                                 name="email"
                                                 error={this.state.emailError}
                                                 className="settings-text"
                                                 onChange={(event) => this.handleValue("newEmail", event.target.value)}/>


                                <label className="label-title">Confirmer l'adresse email</label>
                                <EmailInputField value={this.state.checkNewEmail}
                                                 name="emailConfirm"
                                                 required={true}
                                                 className="settings-text"
                                                 error={this.state.emailError}
                                                 onChange={(event) => this.handleValue("checkNewEmail", event.target.value)}/>


                                <label className="label-title">Mot de passe actuel</label>
                                <PasswordInputField value={this.state.emailPassword}
                                                    name="currentPassword"
                                                    required={true}
                                                    className="settings-text"
                                                    onChange={(event) => this.handleValue("emailPassword", event.target.value)}/>

                            </div>

                            {this.props.userEmailError && this.props.userEmailError.statusCode === 400 &&(
                                <span className="warning">{this.props.userEmailError.message}</span>
                            )}
                            <div className="settings-btn-group">
                                <Can action={"update-email"} subject={"User"}>
                                    <Button size={"medium"}
                                            btnType={"submit"}
                                            loading={this.props.userEmailSubmitting}
                                            btnStyle={"primary-reverse"}
                                            content={"Enregistrer"}/>
                                </Can>
                            </div>
                        </form>
                    </div>
                    <div className={"block"}>
                            <form onSubmit={(e) => this.handleSubmitPassword(e)}>
                                <div className="content">
                                    <h4 className="settings-sub-title">Mot de passe</h4>
                                    <p>Pour changer votre mot de passe nous allons envoyer un lien à votre adresse email sur lequel vous devrez cliquer.</p>
                                    <div className="settings-btn-group">
                                        <Can action={"update-password"} subject={"User"}>
                                            <Button size={"medium"}
                                                    btnType={"submit"}
                                                    loading={this.props.userPasswordSubmitting}
                                                    btnStyle={"primary-reverse"}
                                                    disabled={this.state.passwordEmailSent}
                                                    content={this.state.passwordEmailSent ? "Email envoyé !" : "Envoyer l'email pour changer mon mot de passe"}/>
                                        </Can>
                                    </div>
                                </div>
                            </form>


                    </div>



                    <div className={"block"}>
                        {!this.props.currentUser.deleteAccount.isCurrentDemand ? (
                            <form onSubmit={(e) => this.handleSubmitSuppression(e)}>
                                <div className="content">
                                    <h4 className="settings-sub-title">Supprimer mon compte</h4>
                                    <p className={"text-danger"}>Attention, cette opération est définitive ! Si vous supprimez votre compte vous perdrez l’intégralité de vos contenus, messages, photos, vidéos, etc. </p>
                                    <label className="label-title">Mot de passe actuel</label>
                                    <PasswordInputField value={this.state.suppressionPassword}
                                                        name="currentPassword"
                                                        required={true}
                                                        className="settings-text"
                                                        onChange={(event) => this.handleValue("suppressionPassword", event.target.value)}/>

                                </div>

                                {this.props.requestSuppressionAccountError && this.props.requestSuppressionAccountError.error && this.props.requestSuppressionAccountError.statusCode === 400 &&(
                                    <span className="warning">{this.props.requestSuppressionAccountError.message}</span>
                                )}

                                <div className="settings-btn-group">
                                    <Button size={"medium"}
                                            btnType={"submit"}
                                            loading={this.props.requestSuppressionAccountSubmitting}
                                            btnStyle={"cancel-reverse"}
                                            content={"Supprimer mon compte"}/>

                                </div>
                            </form>
                        ) : null}

                        {this.props.currentUser.deleteAccount.isCurrentDemand ? (
                            <div>
                                <div className="content">
                                    <h4 className="settings-sub-title">Supprimer mon compte</h4>
                                    {this.props.currentUser.deleteAccount.isConfirmDemand ? (
                                        <span>
                                            <p>Vous avez demandé la suppression de votre compte il y a plus de 24 heures.</p>
                                            <p>Votre délai de réflexion est maintenant écoulé, mais vous avez toujours la possibilité d’annuler votre demande.</p>
                                            <p>Si vous confirmez la suppression de votre compte, celle-ci est définitive.</p>
                                    </span>
                                    ) : (<span>
                                        <p>Votre demande de suppression de compte a bien été prise en compte.</p>
                                        <p>Dans moins de 24 heures, vous recevrez un e-mail avec la possibilité de confirmer votre demande de manière définitive.</p>
                                        <p>D’ici-là vous pouvez encore annuler cette demande.</p>
                                    </span>)}
                                </div>

                                {this.props.requestSuppressionAccountError && this.props.requestSuppressionAccountError.error && this.props.requestSuppressionAccountError.statusCode === 400 &&(
                                    <span className="warning">{this.props.requestSuppressionAccountError.message}</span>
                                )}

                                <div className="settings-btn-group">
                                    {this.props.currentUser.deleteAccount.isConfirmDemand ? (
                                        <Button size={"medium"}
                                                className={"mr-8"}
                                                onClick={()=>{history.push(createLink("deleteAccount"))}}
                                                btnStyle={"cancel-reverse"}
                                                content={"Confirmer la suppression"}/>
                                    ) : null}

                                    <Button size={"medium"}
                                            onClick={() => this.props.cancelRequestSuppressionUser(this.props.currentUser._id)}
                                            loading={this.props.requestSuppressionAccountSubmitting}
                                            btnStyle={"primary-reverse"}
                                            content={"Annuler la demande"}/>

                                </div>
                            </div>
                        ) : null}
                    </div>

                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,

        userPassword: state.userPassword.data,
        userPasswordLoading: state.userPassword.loading,
        userPasswordSubmitting: state.userPassword.submitting,

        userEmail: state.userEmail.data,
        userEmailError: state.userEmail.error,
        userEmailLoading: state.userEmail.loading,
        userEmailSubmitting: state.userEmail.submitting,

        requestSuppressionAccount: state.requestSuppressionAccount.data,
        requestSuppressionAccountError: state.requestSuppressionAccount.error,
        requestSuppressionAccountLoading: state.requestSuppressionAccount.loading,
        requestSuppressionAccountSubmitting: state.requestSuppressionAccount.submitting,


    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,
    updateCurrentUser,

    updateUserEmail,
    updateUserPassword,

    requestSuppressionUser,
    cancelRequestSuppressionUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPasswordEmail);